import { render } from "./WarehouseDashboard.vue?vue&type=template&id=32d0f768&scoped=true&lang=true"
import script from "./WarehouseDashboard.vue?vue&type=script&lang=js"
export * from "./WarehouseDashboard.vue?vue&type=script&lang=js"

import "./WarehouseDashboard.vue?vue&type=style&index=0&id=32d0f768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d0f768"]])

export default __exports__